/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Column_Notes_CheckInputs */



/**
* | output |
* | --- |
* | "Notes Check" |
*
* @param {Editor_Table_Column_Notes_CheckInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_column_notes_check = /** @type {((inputs?: Editor_Table_Column_Notes_CheckInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Column_Notes_CheckInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verification notes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Notizen prüfen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Verifica delle note")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверка примечаний")
	if (locale === "es") return /** @type {LocalizedString} */ ("Revisión de notas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("备注检查")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メモの確認")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नोट्स चेक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Verificação de notas")
	return /** @type {LocalizedString} */ ("Notes Check")
});